<template>
  <svg id="plus" viewBox="0 0 64 64">
    <svg>
      <path
        d="M32.1,64C14.5,64,0.2,49.7,0.2,32.1c0-17.6,14.3-31.9,31.9-31.9C49.7,0.2,64,14.5,64,32.1C64,49.7,49.7,64,32.1,64z
                     M32.1,4.8c-15,0-27.3,12.2-27.3,27.3s12.2,27.3,27.3,27.3c15,0,27.3-12.2,27.3-27.3S47.1,4.8,32.1,4.8z"
      />
    </svg>
    <polygon
      points="29.2,42.7 29.2,35 21.6,35 21.6,29.2 29.2,29.2 29.2,21.6 35,21.6 35,29.2 42.7,29.2 42.7,35 35,35
                35,42.7 	"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconPlus extends Vue {}
</script>
